import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { supabase } from '../../../supabaseClient';


const ProductActionButton = ({goods_seq, bottom, right}) => {
    const { profile } = useAuth(); 
    const navigate = useNavigate();
    const [isLiked, setIsLiked] = useState(false);
    const [isCarted, setIsCarted] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    //찜, 카트 상태 확인
    useEffect(() => {
        const fetchData = async () => {
            if (!profile) return;

            const {count: countLike, error: errorLike} = await supabase
            .from('tb_store_goods_interest').select('*',{ count: 'exact', head: true})
            .eq('member_seq', profile.member_seq)
            .eq('goods_seq', goods_seq)
            .eq('use_yn', 'Y');

            if (errorLike) {console.error(errorLike);}
            else {setIsLiked(countLike>0);} //카운트 결과가 0보다 크면 찜을 누른 상태

            const { count: countCart, error: errorCart } = await supabase
            .from('tb_store_goods_basket').select('*',{ count: 'exact', head: true})
            .eq('member_seq', profile.member_seq)
            .eq('goods_seq', goods_seq);

            if (errorCart) {console.error(errorCart);}
            else {setIsCarted(countCart>0);} //카운트 결과가 0보다 크면 장바구니에 있는 상태
        }

        fetchData();
        setIsLoading(false);
    }, [isLiked, isCarted, profile, goods_seq]);



    const handleLike = async () => {
        if (!profile) {
            alert('로그인 후 이용해주세요.');
            navigate('/login');
            return
        }
        //찜을 누른 상태일때는 찜을 취소 (use_yn = 'N')
        if(isLiked) {
            const { error } = await supabase
            .from('tb_store_goods_interest')
            .update({ use_yn: 'N' })
            .eq('member_seq', profile.member_seq)
            .eq('goods_seq', goods_seq);

            if(error) {
                alert('찜 취소 실패');
            }
            else {
                setIsLiked(false);
            }
        }

        //찜을 안 누른 상태일때는 찜을함.
        else {
            const { error } = await supabase
            .from('tb_store_goods_interest')
            .upsert(
                { member_seq: profile.member_seq, goods_seq: goods_seq, use_yn: 'Y' },
                { onConflict: ['member_seq', 'goods_seq'] }
              );

            if(error) {
                alert('찜 실패');
            }
            else {
                setIsLiked(true);
            }
        }      
    }

    const handleCart = async () => {
        if (!profile) {
            alert('로그인 후 이용해주세요.');
            navigate('/login');
            return;
        }

       //장바구니에 있는 상태일때는 찜을 취소 (use_yn = 'N')
       if(isCarted) {
        const { error } = await supabase
        .from('tb_store_goods_basket')
        .delete()
        .eq('member_seq', profile.member_seq)
        .eq('goods_seq', goods_seq);

        if(error) {
            alert('장바구니 삭제 실패');
        }
        else {
            setIsCarted(false);
        }
       }
    
        //장바구니에 없을때는 추가.
        else {
            const { error } = await supabase
            .from('tb_store_goods_basket')
            .insert({member_seq: profile.member_seq, goods_seq: goods_seq});

            if(error) {
                alert('찜 실패');
            }
            else {
                setIsCarted(true);
            }
        }      
    }
    
    if(isLoading) {
        <div className="product-actions">
            <div className="product-action-buttons">
                <button className="action-button">
                    <img src="" alt=""/>
                </button>
                <button className="action-button">
                    <img src="" alt=""/>
                </button>
            </div>
        </div>
    }

    return (
        <div className="product-actions">
            <div className="product-action-buttons">
                <button className="action-button" onClick={()=>handleLike(goods_seq)} data-active={isLiked}>
                    {isLiked && (<img src="/icon_like_active.svg" alt=""/>)}
                    {!isLiked && (<img src="/icon_like.svg" alt=""/>)}
                    
                </button>
                <button className="action-button" onClick={()=>handleCart(goods_seq)} data-active={isCarted}>
                    {isCarted && (<img src="/icon_cart_active.svg" alt=""/>)}
                    {!isCarted && (<img src="/icon_cart.svg" alt=""/>)}
                </button>
            </div>
        </div>
    )
}

export default ProductActionButton;